/*global define*/
define('core/services/TrackingService',['angular'], function(angular) {
    'use strict';
    return angular.module('dnaApp').service('TrackingService', ['$log', '$window', '$http', function ($log, $window, $http) {

        var KEY_TIMESTAMP = 'TimeStamp';
        var KEY_GROUP_NAME = 'GroupName';
        var GROUP_NAME = 'DNA';
        var KEY_SERVICE_NAME = 'ServiceName';
        var SERVICE_NAME = 'AUT';
        var KEY_HOST = 'Host';
        var HOST = 'Dna-Server'; // This name may change.

        function sendToFel(eventName, felProperties) {

            var url = dna.app.felServiceUrl + '/avro/' + eventName;

            felProperties[KEY_TIMESTAMP] = new Date().toISOString();
            felProperties[KEY_GROUP_NAME] = GROUP_NAME;
            felProperties[KEY_SERVICE_NAME] = SERVICE_NAME;
            felProperties[KEY_HOST] = HOST;

            // Remove the dnaVersion header so that FEL doesn't puke.
            $http({
                withCredentials: true,
                method: 'POST',
                url: url,
                headers: {dnaVersion: undefined},
                data: felProperties
            });
        }

        /**
         * Checks the validity of the given name.
         * @param {String} name The name to check.
         * @returns {Boolean} Whether the name is valid.
         * @private
         */
        function validateName(name) {
            if (name.indexOf(':') !== -1) {
                $log.warn("Error: pageArea/pageName/eventName cannot contain a colon (':') character. Validating name failed.", name);
                return false;
            } else {
                return true;
            }
        }

        /**
         * Used for tracking page views.
         * @param {String} pageArea The name of the page area.
         * @param {String} pageName The name of the page.
         * @private
         */
        function trackPage(pageArea, pageName) {
            try {
                if (!validateName(pageArea) || !validateName(pageName)) {
                    return;
                }

                // Check for pageArea and pageName, if either not set, put in standard problem area.
                pageArea = pageArea ? pageArea : 'pageAreaOrNameNotSet';

                // Call tracking code.
                var pageviewData = {
                    page_name: dna.app.omnitureLog + ' : dna : ' + pageArea + ' : ' + pageName
                };
                if ($window.utag && $window.utag.view) {
                    $window.utag.data.page_name = pageviewData.page_name;
                    $window.utag.view(pageviewData);
                } else {
                    $window.addEventListener('tealiumReady', function () {
                        $window.utag.data.page_name = pageviewData.page_name;
                        $window.utag.view(pageviewData);
                    });
                }
            } catch (e) {
                $log.warn('Error logging page view:', e);
            }
        }

        /**
         * Used for validating an event object.
         * @param {Object} linkData The event object to validate.
         * @private
         */
        function isValidLinkData(linkData) {
            var isValid = false;
            if (linkData && linkData.link_name && linkData.action) {
                if (linkData.link_name.trim() !== '' && linkData.action.trim() !== '') {
                    isValid = true;
                }
            }
            return isValid;
        }

        /**
         * Used for transmitting an event.
         * @param {Object} linkData The event object to transmit.
         * @private
         */
        function transmitEvent(linkData) {
            try {
                if (!isValidLinkData(linkData)) {
                    throw 'Invalid linkData';
                }
                if ($window.utag && $window.utag.link) {
                    $window.utag.link(linkData);
                } else {
                    $window.addEventListener('tealiumReady', function () {
                        $window.utag.link(linkData);
                    });
                }
            } catch (e) {
                $log.warn('Error transmitting event:', e);
            }
        }

        /**
         * Used for creating a default event based on the current page.
         * @param {String} eventPostfix The string fragment to add to the action property.
         * @param {Object} addtlData Additional data to include in the eventData object.
         * @private
         */
        function createDefaultEvent(eventPostfix, addtlData) {
            var defaultData = {
                link_name: $window.utag.data.page_name,
                action: $window.utag.data.page_name + (eventPostfix ? ' : ' + eventPostfix : '')
            };
            var eventData = angular.extend(defaultData, addtlData || {});
            return eventData;
        }

        /**
         * Used for tracking any event.
         * @param {String} eventName The name of the event.
         * @private
         */
        function trackEvent(eventName) {
            try {
                if (!validateName(eventName)) {
                    return;
                }
                var linkData = createDefaultEvent(eventName);
                transmitEvent(linkData);
            } catch (e) {
                $log.warn('Error logging event:', e);
            }
        }

        function trackEventOnlyOnPage(eventName, requiredPageName) {
            if (requiredPageName === undefined || requiredPageName === null) {
                trackEvent(eventName);
            } else if ($window.utag && $window.utag.view && $window.utag.data && $window.utag.data.page_name && $window.utag.data.page_name.indexOf(requiredPageName) !== -1 ) {
                trackEvent(eventName);
            }
        }

        return {
            KEY_PAGE_NAME: 'PageName',
            KEY_TEST_ID: 'TestId',
            KEY_OBJECT_TYPE: 'ObjectType',
            KEY_SUCCESS_SOURCE_TYPE: 'SuccessSourceType',

            createDefaultEvent: createDefaultEvent,

            trackPageFel: sendToFel,

            transmitEvent: transmitEvent,

            trackPage: trackPage,

            trackEvent: trackEvent,

            trackEventOnlyOnPage: trackEventOnlyOnPage
        };
    }]);
});

